module.exports = __webpack_public_path__ + "img/tauko_design.cf19bbd3.png";